// extracted by mini-css-extract-plugin
export var content = "Blockcontent-module--content--2lNAO";